module.exports = __webpack_public_path__ + "img/img07.9334d0cc.png";